import { render } from "./mainNav.vue?vue&type=template&id=24a9c6c0&lang=true"
import script from "./mainNav.vue?vue&type=script&lang=js"
export * from "./mainNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__